export const TRIAL_START_ENDPOINTS = {
  VALIDATE_EMAIL: '/app_support/email/validate',
  START: '/companies/trial/start',
};

export const TRIAL_START_QUERY_KEYS = {
  VALIDATE_EMAIL: 'TRIAL_START_VALIDATE_EMAIL',
  START: 'TRIAL_START',
};
